export const state = {
    cargo: {},
    cargos: [],
    modalCadastroCargo: false,
    modalExcluirCargo:false
}

export default {}